import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Feedback, FeedbackAdapter, FeedbackStatus } from '../models/feedback.model';

@Injectable()
export class FeedbackService {
    private api: string;

    constructor(private http: HttpClient, private adapter: FeedbackAdapter) {
        this.api = `${environment.apiRoot}${environment.apiEndpoints.feedback}`;
    }

    submit(text: string, url: string): Observable<Feedback> {
        return this.http.put<any>(this.api, { text, url }).pipe(
            map(response => this.adapter.adapt(response.feedback))
        );
    }

    list(status: FeedbackStatus = 'new'): Observable<Feedback[]> {
        return this.http.get<any>(`${this.api}?status=${status}`).pipe(
            map(response => (response.feedback as any[]).map(item => this.adapter.adapt(item)))
        );
    }

    updateStatus(id: string, status: FeedbackStatus): Observable<Feedback> {
        return this.http.post<any>(`${this.api}/${id}`, { status }).pipe(
            map(response => this.adapter.adapt(response.feedback))
        );
    }
}
